import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as Api from '@/app/state-serialization/api'
import { ShortAnswerAnswer, ShortAnswerUserAnswer } from './short-answer-interfaces'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';

interface ShortAnswerUserAnswerItem {
  key: string;
  val: string;
}

@injectable()
export class ShortAnswerQuestionAnswerProtobufSerializer implements Api.StateSerializationPlugin<ShortAnswerAnswer> {

  key = { id: 18, name: { ns: 'suspend-data', name: 'question-answer-short-answer' }, format: 'protobuf' }

  serialize(data: ShortAnswerAnswer): Result<Uint8Array, Api.SerializerError> {
    const userAnswers: ShortAnswerUserAnswerItem[] = [];

    for (let i in data.userAnswers) {
      userAnswers.push({
        key: i,
        val: data.userAnswers[i],
      })
    }

    const message = new ShortAnswerAnswerProtoMessage({
      userAnswers,
    })

    return ProtobufSerializer.serialize<ShortAnswerAnswerProtoMessage>(message, ShortAnswerAnswerProtoMessage)
  }

  deserialize(content: Uint8Array): Result<ShortAnswerAnswer, Api.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<ShortAnswerAnswerProtoMessage>(content,
                                                                                       ShortAnswerAnswerProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const userAnswers: ShortAnswerUserAnswer = {};
    const message = deserializeResult.value;
    message.userAnswers.forEach(answer => userAnswers[answer.key] = answer.val);

    const result: ShortAnswerAnswer = {
      userAnswers,
    }
    
    return ok(result)
  }
}

@Type.d("ShortAnswerUserAnswersProtoMessage")
class ShortAnswerUserAnswersProtoMessage extends Message<ShortAnswerUserAnswersProtoMessage> {
  @Field.d(1, "string", "optional", "")
  key: string;

  @Field.d(2, "string", "optional", "")
  val: string;
}

@Type.d('ShortAnswerAnswerProtoMessage')
class ShortAnswerAnswerProtoMessage extends Message<ShortAnswerAnswerProtoMessage> {
  @Field.d(1, ShortAnswerUserAnswersProtoMessage, 'repeated')
  userAnswers: ShortAnswerUserAnswerItem[]
}
